import React, { useState, useEffect } from 'react';
import { Grid, Box,Typography } from '@mui/material';
import { Formik, Form } from 'formik';
import FormikControl from '../../../../components/FormikControls/FormikControl';
// import { AddEvalFace } from '../../Interfaces/interfaces';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import { currentStateActionsOptions, iSchema, nextStateActionOptions } from '../../StataicData';
import { useAddCommitments } from '../../Hooks/index';
import { useSelector } from 'react-redux';
// import AddMeetingSuccess from '../../../Meeting/LComponents/AddMeetingSuccess/AddMeetingSuccess';
// import { intaddKrSchema,straddKrSchema } from '../../StataicData';
import { useGetAllActivePersonByTenantId } from "../../../CompanyManagment/Hooks";
import { useGetAllObjectiveOKRStateByTenantId } from '../../../IndexManaging/Hooks/Index';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';

const  CreateKrAction = ({ cancelo, kresultId,onsucces,pointingSystem,afterAddKr,
    objective,krDetail,rowSelectedData,onClose }: any) => {
  const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
  const profileTenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
  // const priodId: any = useSelector((state: any) => state.meetings.priodId);
  const teamId: any = useSelector((state: any) => state.meetings.teamInfo?.id);
  const priodName = useSelector((state: any) => state.meetings.periodName);
  const meetSelectedDate = useSelector((state: any) => state.meetings.meetSelectedDate);

  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const { data: personsOptionds } = useGetAllActivePersonByTenantId(tenantId);
  const [ShowActionsModal, setShowActionsModal] = useState<Boolean>(false);
const [pointSystemsL,setPointSystemL]=useState<string>('')
  useEffect(() => {
    if(pointingSystem==='مرحله ای'){
      setPointSystemL('req')
    }
   
  }, [pointingSystem]);

  const evaluationData: any = {
    newValue: '',
    problems: '',
    nextState: '',
    meetingId: meetingId,
    teamId: teamId,
    // periodId: priodId,
    tenantId: profileTenantId,
    keyResultId: kresultId,
    objectiveId: objective?.id,
    currentState: '',
    description: '',
    closedKeyResult: false
  }

  const { mutate: addCheck, data:addCheckingData, isSuccess,isLoading } = useAddCommitments();
//   const [renderState, setRenderState] = useState<string>('add');s
  const [showToastMessage, setShowToastMessage] = useState<any>(false);
  const [showToastMessageResult, setShowToastMessageResult] = useState<any>('');
  const [okrStateId, setOkrStateId] = useState<string>("");
  const { data: submitOptions } =
    useGetAllObjectiveOKRStateByTenantId(tenantId);

  useEffect(() => {
    if (addCheckingData) {
      if (addCheckingData?.data.isSuccess) {
         setShowToastMessage(true)
         setShowToastMessageResult(addCheckingData?.data.metaData.message);
        //  setAddEvalAsyncData(addCheckingData?.data)
        onClose(false)
      } else {
        setShowToastMessageResult(addCheckingData?.data.metaData.message);
        setShowToastMessage(true);
      }   
  }
    }, [addCheckingData])

  const initialSubmitForm: any = (data: any): any => {
    data.objectId=krDetail?.id;
    data.okrStateId = okrStateId;
    addCheck(data)
  }
  
  const[krDetailSps,setKrDetailSps]=useState<any>(null);

  useEffect(() => {
    if (krDetail && objective ) {
      let{name}=krDetail;
      let{name:objectiveName}=objective;
      let details:any={
        krName:name,
        objectiveName:objectiveName,
        priodName:priodName
      }
      setKrDetailSps(details)
    }
  }, [krDetail,objective])

  const[initialValuesForm,setInitialValuesForm]=useState<any>({description:''})
  useEffect(() => {
  if (rowSelectedData) {
    let{description,problems,predict,currentStateValue}=rowSelectedData;
    setInitialValuesForm((prev:any)=>({description:description,problems:problems,nextState:predict,currentState:currentStateValue}))
  }
  }, [rowSelectedData])
  
  return (
    <>
      <Formik
           validationSchema={iSchema}
           enableReinitialize
            initialValues={{...evaluationData,...ShowActionsModal}}
            onSubmit={(data: any) => {
              initialSubmitForm(data)
            }}
          >
            {
              ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }:any) =>
                <Form>
                  {
                    true && 
                    <Grid container columnSpacing={1} sx={{bgcolor: 'background.paper',mx:'auto',borderRadius:3}}   >
                    <Grid item xs={12}  >
                    <Box display={'flex'} justifyContent={'space-between'}  >
              <Box  py={1} px={2}>
                <Typography fontWeight={700}  fontSize={'13px'}  >
                  نام هدف  :
                  {
                  krDetailSps?.objectiveName
                  }
                </Typography>
              </Box>
              <Box  py={1} px={2}>
              <Typography variant='body1'  fontSize={'15px'} >
                  {
                  meetSelectedDate
                  }
                </Typography>
         </Box>
        </Box>
         <Box  py={1} px={2}  >
          <Typography variant='body2' fontSize={'13px'}>
            شرح نتیجه کلیدی :
            {
            krDetailSps?.krName
            }
          </Typography>
         </Box>
         <Box  py={1} px={2}  >
          <Typography variant='body2'  fontSize={'13px'}>
                شرح:
                {
                values?.text 
                }
          </Typography>
         </Box>
                    </Grid> 
                    <Grid item xs={12}  >
                      <FormikControl
                        control='textField'
                        type='text'
                        label='شرح'
                        name='text'
                        fullWidth
                        value={values?.text || ''}
                        placeholder={'(اجباری)  0/100'}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control="select"
                         type='select'
                        label='مسئول'
                        options={personsOptionds || []}
                        withIcon={true}
                        name='personId'
                        fullWidth
                        value={values?.personId || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='select'
                        type='select'
                        label='اولویت'
                        options={currentStateActionsOptions}
                        name='commitmentsPriority'
                        fullWidth
                        value={values?.commitmentsPriority || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='select'
                        type='select'
                        label='وضعیت'
                        options={nextStateActionOptions}
                        name='commitmentsStatus'
                        fullWidth
                        value={values?.commitmentsStatus || ''}
                      />
                    </Grid>
                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='date'
                        type='date'
                        label='تاریخ شروع'
                        name='startDate'
                        fullWidth
                        value={values?.startDate || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <FormikControl
                        control="timePicker"
                        name="startTime"
                        label="زمان شروع"
                        value={values.startTime}
                      />
                    </Grid>

                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='date'
                        type='date'
                        label='موعد مقرر'
                        name='duedate'
                        fullWidth
                        value={values?.duedate || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <FormikControl
                        control="timePicker"
                        name="dueTime"
                        label="زمان مقرر"
                        value={values.dueTime}
                      />
                    </Grid>

                    <Grid item xs={12}  >
                      <FormikControl
                        control='textField'
                        type='text'
                        label='توضیحات'
                        name='description'
                        fullWidth
                        value={values?.description || ''}
                        placeholder={'توضیحات (اختیاری)  0/100'}
                      />
                    </Grid>

                <Grid item xs={12} md={12} mt={3}>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"end"}
                    flexDirection={"row-reverse"}
                    columnGap={2}
                  >
                    {submitOptions &&
                      submitOptions?.map((item: any, i: number) => {
                        let { label, id } = item;
                        // console.log(item)
                        return (
                          <Box width={"20%"}>
                            <DyButton
                              disabled={false}
                              key={i}
                              type={"submit"}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={label}
                              onClick={() => {
                                setOkrStateId(id);
                              }}
                            />
                          </Box>
                        );
                      })}
                  </Box>
                </Grid>


                {setShowToastMessage && (
          <DYToastMessage
            isSuccess={addCheckingData?.data.isSuccess}
            message={showToastMessageResult}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
         {/* {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )} */}
                  </Grid>
                  }          
                </Form>
            }
      </Formik>
    </>
  )
}

export default CreateKrAction